import type { ReactNode } from "react";
import { useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/loaders/PageLoader";

/**
 * The app-wide loader shown while the FIRST Firebase auth pass settles.
 *
 * It gates on `bootstrapping` only, never on a later transition: a sign-in or
 * sign-out after bootstrap must leave every route mounted. The public
 * /auth/email-callback and /accept-invite pages redeem single-use codes, and an
 * unmount mid-flight made the remount redeem them a second time (plan
 * 2026-10-28-partner-aware-invitation-flow, D6). Guards that do want to wait
 * for a transition read `loading` themselves (ProtectedRoute).
 */
export function AuthBootstrapGate({ children }: { children: ReactNode }) {
  const { bootstrapping } = useAuth();
  if (bootstrapping) return <PageLoader dark={false} />;
  return <>{children}</>;
}
